<!-- Barra para adicionar conteudo entre sessoes -->
<template>
    <div class="add-last-frame">
        <button
          v-if="!isOpen"
          @click="toggleOpen"
          v-b-tooltip.hover
          title="Adicionar Conteúdo"
          :class="[`button-add--last-frame`, extraClass]"
          :style="extraStyle"
        >
            <i class="fal fa-plus mr-2 mr-md-0"></i>

          <span class="d-block d-md-none">
            Adicionar Conteúdo
          </span>
        </button>

        <div
          v-if="isOpen"
          @mouseleave="() => closePopover()"
          :class="[`button-add--last-frame--popover button-add--last-frame--popover--bottom flex-row`]"
          :style="extraStyle"
        >
            <button
              v-for="(button, index) in frameButtons"
              :key="button.index"
              @click="clickAddLastFrame(index)"
              v-b-tooltip.hover
              :title="button.tooltip"
              :class="['btn d-flex justify-content-center align-items-center']"
            >
              <i v-if="button.icon" :class="['fa-lg', button.icon]"></i>

              <img
                v-else
                class="img-svg img-svg-color"
                src="../../assets/img/icons/before-after.svg"
              />
            </button>

            <button
              v-if="showButtonPreset"
              @click="() => showModalPresetFrames = true"
              class="btn d-flex justify-content-center align-items-center"
              v-b-tooltip.hover
              title="Adicionar predefinição"
            >
              <i class="fal fa-browser fa-lg"></i>
            </button>
        </div>

        <modal-preset-frames
          v-if="showButtonPreset"
          title="Adicionar Conteúdo Predefinido"
          :filters="filters"
          :show="showModalPresetFrames"
          textButtonPrimary="Adicionar"
          textButtonClose="Cancelar"
          @handleButtonPrimary="handleCreate"
          @handleButtonClose="() => showModalPresetFrames = false"
        />
    </div>
</template>

<script>
import ModalPresetFrames from '../organisms/ModalPresetFrames.vue';

export default {
  components: { ModalPresetFrames },
  name: "AddLastFrame",
  data() {
    return {
      isOpen: false,
      showModalPresetFrames: false,
      filters: [
        {
          id: 1,
          name: 'Todos',
          type: '',
        },
        {
          id: 2,
          name: 'Texto',
          type: 'text',
        },
        {
          id: 3,
          name: 'Imagem',
          type: 'image',
        },
        {
          id: 4,
          name: 'Galeria',
          type: 'gallery',
        },
        {
          id: 5,
          name: 'Botão',
          type: 'button',
        }
      ]
    };
  },
  methods: {
    toggleOpen() {
      if (this.remainOpen) {
        this.$emit("return-slot", this.slotNum);
        
        return;
      }

      this.isOpen = !this.isOpen;

      this.$emit("return-slot", this.slotNum);
    },
    closePopover() {
      if (this.remainOpen) {
        return;
      }

      this.isOpen = false;
    },
    clickAddLastFrame(index) {
      this.toggleOpen();

      this.$emit('click-add-last-frame', index)
    },
    handleCreate(activePreset) {
      this.$emit("return-slot", this.slotNum);

      this.$emit("add-frame", activePreset);

      this.showModalPresetFrames = false;
    },
  },
  watch: {
    isOpen(newValue, oldValue) {
      if (newValue) {
        this.$root.$emit('bv::show::popover', 'add-last-frame')
      } else {
        this.$root.$emit('bv::hide::popover', 'add-last-frame')
      }
    },
  },
  props: {
    remainOpen: {
      type: Boolean,
      default: false,
    },
    frameButtons: Array | null,
    slotNum: Number | null,
    extraStyle: String | null,
    extraClass: String | null,
    showButtonPreset: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    if (this.remainOpen) {
      this.isOpen = true;
    }
  },
};
</script>

<style scoped>
  .button-add--last-frame {
    background-color: #fff;
    border: 2px solid #ccc;
    width: 32px;
    height: 32px;
    color: #ccc;
    border-radius: 50%;
    position: absolute;
    z-index: 9;
    left: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
  }

  .button-add--last-frame:hover {
    border-color: var(--main-color);
    color: #fff;
    background-color: var(--main-color);
  }

  .button-add--last-frame--popover {
    display: flex;
    padding: 15px 15px;
    align-items: center;
    position: absolute; 
    z-index: 99;
    background-color: var(--light);
    border-radius: 5px;
    box-shadow: 0 6px 20px 1px #dedede;
  }
  
  .button-add--last-frame--popover--bottom {
    left: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: 768px) {
    .button-add--last-frame {
      border-radius: 24px;
      padding: .3rem .5rem;
      width: auto;
      height: auto;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/molecules/AddLastFrame.vue